import { UserBodyDtoRole } from '@api/WhisApi/generated/model/userBodyDtoRole';
import { Ionicons } from '@expo/vector-icons';

/**
 * Enum for navigation tabs to avoid index-based access and ensure type safety.
 */
export enum TabName {
  board = 'board',
  reports = 'reports',
  reportCreation = 'report-creation',
  resources = 'resources',
  notifications = 'notifications',
  userManagement = 'user-management',
  profile = 'profile',
}

/**
 * Interface for tab configuration.
 */
export interface TabItem {
  name: TabName;
  labelKey: string;
  iconName: keyof typeof Ionicons.glyphMap;
  /**
   * Allow-list: if set, only these roles can see/access this tab.
   * If undefined/empty, everyone can (unless excluded by `hiddenFrom`).
   */
  visibleTo?: UserBodyDtoRole[];
  /**
   * Deny-list: these roles can never see/access this tab.
   * Takes priority over `visibleTo`.
   */
  hiddenFrom?: UserBodyDtoRole[];
}

const tabNames = Object.values(TabName);

export const isTabName = (value: string | undefined): value is TabName =>
  typeof value === 'string' && tabNames.some((tabName) => tabName === value);
